import { Grid } from '@mui/material';
import { FC, ReactNode } from 'react';
import { Container } from './Layout.helper';

interface LayoutProps {
  sidebar?: boolean;
  topNav?: boolean;
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const isWindow = typeof window !== 'undefined';

  if (!isWindow) {
    return <div></div>;
  }

  return (
    <Grid item xs={12} component={Container}>
      {children}
    </Grid>
  );
};
